import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { useNavigate } from 'react-router-dom';
import { signOut, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import Spinner from '../components/Spinner';

export default function Dashboard() {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [userInitial, setUserInitial] = useState('U');
  const [profileBg, setProfileBg] = useState('#e5e7eb');

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'cars'));
        const carList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setCars(carList);
      } catch (error) {
        console.error('Error fetching cars:', error);
      } finally {
        setLoading(false); // ✅ Stop loading
      }
    };

    fetchCars();

    // Set user initial and random color
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const name = user.displayName || user.email || 'U';
        setUserInitial(name.charAt(0).toUpperCase());
        // Generate a random pastel color
        const colors = ['#f59e42', '#10b981', '#3b82f6', '#ef4444', '#f472b6', '#fbbf24', '#6366f1', '#34d399'];
        setProfileBg(colors[Math.floor(Math.random() * colors.length)]);
      }
    });
    return () => unsubscribe();
  }, []);

  if (loading) return <Spinner />;

  return (
    <div style={{ padding: '30px', backgroundColor: '#f9fafa', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px',
      }}>
        {/* Replace title with logo */}
        <img src="/Logo.png" alt="Logo" style={{ height: 66, objectFit: 'contain', marginRight: 12 }} />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <button
            onClick={() => navigate('/rent')}
            style={buttonStyle('#10b981')}
          >
            + Rent Car
          </button>
          <button
            onClick={() => navigate('/add')}
            style={buttonStyle('#3b82f6')}
          >
            + Add Car
          </button>
          <div style={{ position: 'relative', marginLeft: '10px' }}>
            <button
              onClick={() => setProfileMenuOpen((open) => !open)}
              style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                background: profileBg,
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 20,
                color: '#fff',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                fontWeight: 700,
                letterSpacing: 1
              }}
              aria-label="Profile"
            >
              {userInitial}
            </button>
            {profileMenuOpen && (
              <div style={{
                position: 'absolute',
                top: 50,
                right: 0,
                background: '#fff',
                borderRadius: 10,
                boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                minWidth: 160,
                zIndex: 10,
                padding: '10px 0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
              }}>
                <button
                  onClick={() => { setProfileMenuOpen(false); navigate('/admin'); }}
                  style={{ ...dropdownButtonStyle, borderBottom: '1px solid #eee' }}
                >
                  Admin Page
                </button>
                <button
                  onClick={() => {
                    setProfileMenuOpen(false);
                    signOut(auth).then(() => navigate('/login'));
                  }}
                  style={dropdownButtonStyle}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Car Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        gap: '24px'
      }}>
        {cars.map((car) => (
          <div
            key={car.id}
            onClick={() => navigate(`/car/${car.id}`)}
            style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              overflow: 'hidden',
              cursor: 'pointer',
              boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
              transition: 'transform 0.2s',
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.015)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1.0)'}
          >
            <img
              src={car.imageUrls?.[0] || 'https://via.placeholder.com/300x160?text=No+Image'}
              alt={car.make}
              style={{
                width: '100%',
                height: '160px',
                objectFit: 'cover',
              }}
            />
            <div style={{ padding: '16px' }}>
              <h3 style={{
                margin: 0,
                fontSize: '16px',
                fontWeight: '600'
              }}>
                {car.make} {car.model}
              </h3>
              <p style={labelStyle}><strong>Rego:</strong> {car.rego}</p>
              <p style={labelStyle}><strong>Status:</strong> <span style={{ color: car.status === 'rented' ? '#ef4444' : '#10b981' }}>{car.status}</span></p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// 🔹 Reusable styles
const buttonStyle = (bgColor) => ({
  padding: '10px 16px',
  backgroundColor: bgColor,
  color: '#fff',
  border: 'none',
  borderRadius: '8px',
  marginLeft: '10px',
  cursor: 'pointer',
  fontWeight: '500',
  fontSize: '14px'
});

const dropdownButtonStyle = {
  padding: '10px 16px',
  backgroundColor: '#f9fafa',
  color: '#333',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontWeight: '500',
  fontSize: '14px',
  textAlign: 'left',
  width: '100%',
  transition: 'background-color 0.2s'
};

const labelStyle = {
  margin: '6px 0 0',
  fontSize: '14px',
  color: '#6b7280'
};
